/** The API returns at most 100 rows per request. */
const PAGE_LIMIT = 100;
/** Safety stop: 50 requests (5,000 rows). */
const MAX_PAGES = 50;

/**
 * Loads every page of a paginated list endpoint, for pages that filter,
 * count and page the rows in the browser. `fetchPage` gets (page, limit).
 */
export const fetchAllPages = async <T>(
  fetchPage: (page: number, limit: number) => Promise<{ rows: T[]; totalPages: number }>
): Promise<T[]> => {
  const first = await fetchPage(1, PAGE_LIMIT);
  const pages = Math.min(first.totalPages || 1, MAX_PAGES);
  if (pages <= 1) return first.rows;
  const rest = await Promise.all(
    Array.from({ length: pages - 1 }, (_, i) => fetchPage(i + 2, PAGE_LIMIT))
  );
  return first.rows.concat(...rest.map((r) => r.rows));
};
